Vue.asyncComponent('ak-data-column-settings', {
    emptyState: {
    },
    props: {
        columns: {
            type: Array,
            required: true
        },
        definition: {
            type: String,
            required: true
        },
        bundle: {
            type: String,
            required: true
        },
        title: {
            type: String,
            required: false
        },
        confirmButtonLabel: {
            type: String,
            required: false,
        },
        viewMode: {
            type: String,
            required: false,
            default: 'default'
        },
        showSelectAllToggle: {
            type: Boolean,
        }
    },
    data() {
        return {
            columnData: [],
            saveColumnsUri: null,
            viewModeOptions: [
                {
                    label: this.$t('Normale weergave'),
                    value: 'default'
                },
                {
                    label: this.$t('Compacte weergave'),
                    value: 'compact'
                }
            ],
            selectedViewMode: 'default'
        }
    },
    computed: {
        allColumnsSelected() {
            const selectColumnData = this.columnData.filter(column => column.active);
            return this.columnData.length === selectColumnData.length;
        }
    },
    methods: {
        /**
         * Close the list
         */
        close() {
            this.$emit('close')
        },
        /**
         * Format the column data to send to backend
         */
        createColumnData() {
            this.columns.forEach(column => {
                this.columnData.push({
                    id: column.id,
                    active: column.active
                });
            });
        },
        getColumnData(columnId) {
            return this.columnData.find(x => x.id === columnId);
        },
        /**
         * Update Column
         * Update whether the changed column should be active or not
         *
         * @param flag
         * @param columnId
         */
        updateColumn(flag, columnId) {
            const column = this.getColumnData(columnId);
            column.active = flag;
        },
        /**
         * Update Column Data Order
         * Change the position of the column
         *
         * @param e
         */
        updateColumnDataOrder(e) {
            this.columnData.splice(e.newIndex, 0, this.columnData.splice(e.oldIndex, 1)[0]);
        },
        async saveColumnData() {
            try {
                await this.$post(this.saveColumnsUri, {
                    columns: this.columnData,
                    viewMode: this.selectedViewMode
                });
            } catch (error) {
                console.log(error);
            } finally {
                this.$emit('saved-columns');
            }
        },
        selectAllColumns(flag) {
            this.columnData.forEach(column => column.active = flag);
        }
    },
    watch: {
    },
    mounted() {
        this.selectedViewMode = this.viewMode;
        this.createColumnData();
        this.saveColumnsUri = `/${this.bundle}/${this.definition}/save-columns`;
    }
}, 'grid/ak-data-column-settings.html');